import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinranchi() {



  const cardData =
  {
    keyword: 'Corporate Cab Services in Ranchi',
    heading: 'Aaryan Travels: Corporate Cab Services in Ranchi',
    headingDescription: ' Aaryan Travels offers professional Corporate Cab Services in Ranchi, catering to business executives, government officials, and corporate organizations across the city. Whether you need reliable transportation for daily employee commute, client pickup, airport transfers from Birsa Munda Airport, or intercity business travel, our fleet of sedans, SUVs, and premium cars ensures a safe and comfortable experience. With trained chauffeurs, GPS-enabled vehicles, timely pickups, and monthly rental options, we provide customized cab solutions for corporate mobility. From Kanke Road to Lalpur, Doranda to Hinoo, Aaryan Travels delivers hassle-free and dependable corporate cab services throughout Ranchi with 24/7 availability.',

    top: 'Top Places to Visit in Ranchi with Aaryan Travels',

"topPlaces": [
  {
    "title": "Tagore Hill",
    "description": "Tagore Hill is a peaceful hilltop named after Nobel laureate Rabindranath Tagore, who was believed to have spent time here meditating and writing. The hill offers panoramic views of Ranchi city and is popular among nature lovers and trekkers. A small ashram and library at the base add to its cultural significance. Sunsets from the hilltop are particularly mesmerizing. Tagore Hill is Ranchi’s serene retreat for poetry and peace."
  },
  {
    "title": "Rock Garden & Kanke Dam",
    "description": "Rock Garden is a popular recreational spot built from locally found rocks, offering artistic sculptures, caves, and seating areas. Located adjacent to Kanke Dam, it provides breathtaking lake views and lush surroundings. Evenings here are lively with families and couples enjoying the cool breeze. The unique rock formations make it a favorite photography spot. Rock Garden and Kanke Dam are Ranchi’s scenic leisure escape."
  },
  {
    "title": "Pahari Mandir",
    "description": "Pahari Mandir is a revered hilltop temple dedicated to Lord Shiva, located at an elevation of 2140 feet. Devotees climb nearly 500 steps to reach the shrine, enjoying spectacular views along the way. The national flag hoisted here on Independence Day adds patriotic importance. Festivals like Mahashivratri see massive crowds. Pahari Mandir is Ranchi’s holy summit of devotion."
  },
  {
    "title": "Dassam Falls",
    "description": "Dassam Falls is a majestic waterfall located on the Kanchi River, about 40 km from Ranchi. The water plunges from a height of 144 feet, creating a dramatic and misty spectacle. Surrounded by rugged forests and rocky terrain, it is ideal for nature photography and picnics. The sound of gushing waters adds to the thrill. Dassam Falls is Ranchi’s roaring natural wonder."
  },
  {
    "title": "Patratu Valley",
    "description": "Patratu Valley is known for its winding roads, lush green hills, and breathtaking valley views, comparable to hill stations. The scenic Patratu Dam adds to the beauty with calm waters reflecting the sky. Bike riders and road trip enthusiasts often visit for sunrise drives. Mist-covered hills make it feel like a mini Switzerland. Patratu Valley is Ranchi’s most picturesque drive route."
  },
  {
    "title": "Birsa Zoological Park",
    "description": "Birsa Zoological Park, also known as Ranchi Zoo, is home to tigers, lions, elephants, deer, and numerous bird species. The lush greenery, clean enclosures, and safari rides make it enjoyable for children and wildlife enthusiasts. Educational boards and nature trails promote conservation awareness. Birsa Zoo is Ranchi’s exciting wildlife getaway."
  },
  {
    "title": "Sun Temple",
    "description": "The Sun Temple near Ranchi is designed like a giant chariot with 18 wheels and seven horses, symbolizing the Sun God’s divine ride. Built with sandstone, it offers a stunning architectural sight amidst a scenic pond. The reflection during sunrise is especially captivating. Devotees visit to seek blessings and peace. The Sun Temple is Ranchi’s architectural gem of spirituality."
  },
  {
    "title": "Jagannath Temple",
    "description": "Jagannath Temple in Ranchi is a smaller replica of the famous Puri Temple, built in 1691. Located atop a small hill, it offers peaceful surroundings and great views of the city. The Rath Yatra celebrated here attracts thousands of devotees. The temple's red and white structure stands out beautifully. Jagannath Temple is Ranchi’s sacred cultural landmark."
  },
  {
    "title": "Hundru Falls",
    "description": "Hundru Falls is one of the highest waterfalls in the region, where the Subarnarekha River cascades from a height of 320 feet. The rocky terrain and natural pools below make it perfect for adventure seekers. The waterfall looks especially stunning during monsoon with lush greenery around. Trekking trails add to the excitement. Hundru Falls is Ranchi’s thrilling monsoon spectacle."
  },
  {
    "title": "Nakshatra Van",
    "description": "Nakshatra Van is a unique astrology-themed garden where trees representing 27 constellations (Nakshatras) are planted. Visitors stroll through circular pathways surrounded by medicinal and flowering plants. A small pond and musical fountain enhance the ambiance. It is ideal for relaxing walks and meditation. Nakshatra Van is Ranchi’s cosmic botanical attraction."
  }
],


"services": [
  {
    "name": "Corporate Cab Services in Ranchi",
    "description": "Our Corporate Cab Services in Ranchi are tailored to meet the dynamic transportation needs of businesses and professionals. We offer reliable, comfortable, and punctual rides for daily employee commutes, client meetings, and corporate events. With a modern fleet and trained chauffeurs, our service guarantees seamless travel experiences that enhance business productivity and professionalism in Ranchi's growing corporate landscape."
  },
  {
    "name": "Ranchi Business Taxi",
    "description": "Ranchi Business Taxi service provides efficient and affordable transportation solutions for executives and staff. Whether you require rides to meetings, conferences, or daily office travel, our taxis ensure timely pickups, clean vehicles, and professional drivers who understand the business environment and commute patterns of Ranchi."
  },
  {
    "name": "Office Cab Hire Ranchi",
    "description": "Our Office Cab Hire service in Ranchi caters specifically to corporate clients needing dependable employee transport. With flexible scheduling, fixed routes, and a fleet suited for small and large teams, this service is designed to streamline staff commutes, reduce late arrivals, and boost overall workplace efficiency."
  },
  {
    "name": "Chauffeur Corporate Cabs Ranchi",
    "description": "Enjoy premium travel with our Chauffeur Corporate Cabs in Ranchi, ideal for executives and high-profile business guests. Our professional chauffeurs are trained to provide courteous, safe, and timely service, allowing you to focus on your work while we handle the logistics of your transportation."
  },
  {
    "name": "Monthly Cab Rental Ranchi",
    "description": "Our Monthly Cab Rental service in Ranchi offers businesses an economical and hassle-free way to manage regular employee transportation. By opting for monthly contracts, companies can ensure consistent vehicle availability, transparent billing, and flexible routes that adapt to changing business needs."
  },
  {
    "name": "Ranchi Employee Cab Services",
    "description": "Designed with employee convenience in mind, Ranchi Employee Cab Services provide reliable and comfortable transport for staff across shifts and departments. Our service improves attendance, reduces commute stress, and contributes to higher employee satisfaction and retention."
  },
  {
    "name": "Staff Transport Ranchi",
    "description": "Our Staff Transport service in Ranchi focuses on delivering safe, timely, and comfortable rides for employees of all industries. Equipped with GPS tracking and flexible timing, this service is tailored to meet the unique demands of your workforce's travel schedules."
  },
  {
    "name": "Ranchi Corporate Car Hire",
    "description": "Offering a wide range of corporate car hire options in Ranchi, this service suits client meetings, corporate events, and executive travel. With luxury sedans and SUVs available, all vehicles are maintained to the highest standards and come with experienced chauffeurs for a premium travel experience."
  },
  {
    "name": "Affordable Corporate Cab Ranchi",
    "description": "Our Affordable Corporate Cab service in Ranchi ensures budget-friendly transportation without compromising on quality or comfort. Ideal for startups and growing businesses, this service offers flexible packages to accommodate various corporate travel needs efficiently."
  },
  {
    "name": "Sedan Cab Hire Ranchi",
    "description": "Sedan Cab Hire in Ranchi is perfect for business professionals seeking stylish, comfortable, and reliable rides. Whether for daily commutes or business trips, our sedans are equipped with modern amenities and driven by professional chauffeurs to ensure a smooth travel experience."
  },
  {
    "name": "SUV Rental for Business Ranchi",
    "description": "For businesses requiring spacious and luxurious transport, our SUV Rental service in Ranchi offers premium vehicles ideal for group travel, client transfers, and executive journeys. Enjoy superior comfort, safety, and on-time service tailored to your corporate standards."
  },
  {
    "name": "Ranchi Company Taxi",
    "description": "Our Ranchi Company Taxi service provides organized transport solutions for businesses needing dedicated vehicles for employee travel. With scheduled pickups, reliable drivers, and well-maintained cars, we help companies manage staff commutes efficiently and cost-effectively."
  },
  {
    "name": "Corporate Travel Cab Ranchi",
    "description": "Corporate Travel Cabs in Ranchi offer versatile transportation solutions for business trips, intercity travel, and event transportation. Our fleet includes a variety of vehicle options, ensuring comfort and professionalism for every corporate journey."
  },
  {
    "name": "Online Corporate Cab Booking Ranchi",
    "description": "Easily book your corporate cabs online in Ranchi with our user-friendly platform. Benefit from instant confirmations, secure payments, and customizable travel options that fit your company's needs. Our digital service streamlines corporate travel management for maximum convenience."
  },
  {
    "name": "Best Corporate Taxi Ranchi",
    "description": "Ranked among the best corporate taxi services in Ranchi, we pride ourselves on exceptional service quality, punctuality, and customer satisfaction. Our modern fleet and experienced drivers make us the preferred choice for businesses seeking reliable and professional corporate transportation."
  }
],
"tableData": [
  ["Corporate Cab Services in Ranchi", "Ranchi Business Taxi"],
  ["Office Cab Hire Ranchi", "Chauffeur Corporate Cabs Ranchi"],
  ["Monthly Cab Rental Ranchi", "Ranchi Employee Cab Services"],
  ["Staff Transport Ranchi", "Ranchi Corporate Car Hire"],
  ["Affordable Corporate Cab Ranchi", "Sedan Cab Hire Ranchi"],
  ["SUV Rental for Business Ranchi", "Ranchi Company Taxi"],
  ["Corporate Travel Cab Ranchi", "Online Corporate Cab Booking Ranchi"],
  ["Best Corporate Taxi Ranchi", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Corporate Cab Services in Ranchi",
    "WhyChoosedescription": "Aaryan Travels offers professional and punctual corporate cab services tailored for businesses in Ranchi."
  },
  {
    "WhyChooseheading": "Timely Pickup and Drop for Seamless Commutes",
    "WhyChoosedescription": "Ensure hassle-free daily commutes for your employees with our efficient and punctual cab services."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Business-Class Vehicles",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned cabs designed to provide comfort and professionalism."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Ranchi’s Corporate Routes",
    "WhyChoosedescription": "Our drivers know the key business hubs and routes in Ranchi for smooth navigation."
  },
  {
    "WhyChooseheading": "Transparent Corporate Billing with No Hidden Charges",
    "WhyChoosedescription": "Get clear, GST-compliant invoices and all-inclusive pricing with no surprise costs."
  },
  {
    "WhyChooseheading": "24/7 Dedicated Support for Business Travel Needs",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with corporate bookings and coordination."
  },
  {
    "WhyChooseheading": "Flexible Contract Options: Daily, Weekly, or Monthly",
    "WhyChoosedescription": "Choose short-term or long-term cab hire contracts tailored to your organization’s needs."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles for Corporate Requirements",
    "WhyChoosedescription": "Select from sedans, SUVs, or tempo travellers based on your team size and travel preferences."
  }
]

























  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer corporate cab services in Ranchi?',
    answer: 'Yes, Aaryan Travels provides professional and reliable corporate cab services in Ranchi to meet all business travel needs.',
  },
  {
    question: 'How can I book corporate cab services in Ranchi with Aaryan Travels?',
    answer: 'You can book corporate cabs through our website, mobile app, or by contacting our dedicated corporate support team.',
  },
  {
    question: 'What types of vehicles are available for corporate cab services in Ranchi?',
    answer: 'Aaryan Travels offers a fleet of sedans, SUVs, and premium cars suitable for executive and employee transportation in Ranchi.',
  },
  {
    question: 'Are Aaryan Travels’ corporate cab services suitable for daily employee commute in Ranchi?',
    answer: 'Yes, we provide customized corporate cab solutions for daily employee pickups and drops across Ranchi.',
  },
  {
    question: 'Are drivers experienced and trained for corporate travel requirements in Ranchi?',
    answer: 'Absolutely. Our drivers are professionally trained, courteous, and familiar with Ranchi and its corporate travel standards.',
  },
  {
    question: 'Can Aaryan Travels handle bulk or group cab bookings for corporate events in Ranchi?',
    answer: 'Yes, we specialize in managing group transportation and bulk cab bookings for corporate meetings, events, and conferences in Ranchi.',
  },
  {
    question: 'Do you offer monthly billing or invoice options for corporate cab services in Ranchi?',
    answer: 'Yes, we provide flexible billing options including monthly invoicing for our corporate clients in Ranchi.',
  },
  {
    question: 'Is your corporate cab service in Ranchi available 24x7?',
    answer: 'Yes, Aaryan Travels offers 24x7 corporate cab services to ensure seamless business travel in Ranchi.',
  },
  {
    question: 'What safety measures are in place for corporate cab services in Ranchi?',
    answer: 'All vehicles are sanitized regularly, and our drivers follow strict safety and hygiene protocols to protect passengers.',
  },
  {
    question: 'Can pickup and drop-off locations be customized for corporate cab bookings in Ranchi?',
    answer: 'Yes, we allow full customization of pickup and drop points based on your corporate travel requirements in Ranchi.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Kumar',
    feedback: 'Aaryan Travels’ corporate cab service in Ranchi has been consistently punctual and professional for our company’s commute.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Singh',
    feedback: 'Excellent corporate cab services by Aaryan Travels in Ranchi. Reliable and great customer support.',
    rating: 5,
  },
];
























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Ranchi",
  "image": "https://aaryantravels.com/assets/images/corporate-cab-ranchi.jpg", // replace with actual image URL
  "description": "Affordable and reliable corporate cab services in Ranchi by Aaryan Travels. Ideal for business travel, employee transport, and office cab hire with sedan and SUV options. Book your corporate cab online easily.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.6",  // example rating, update if needed
    "ratingCount": "1500", // example rating count, update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1700",  // example price, adjust as needed
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/corporate-cab-services-ranchi"
  }
};






  return (
    <div>
<Helmet>
  <title>Corporate Cab Services in Ranchi | Business Taxi Hire | Aaryan Travels</title>
  <meta
    name="description"
    content="Affordable and reliable corporate cab services in Ranchi by Aaryan Travels. Ideal for business travel, employee transport, and office cab hire with sedan and SUV options. Book your corporate cab online easily."
  />
  <meta
    name="keywords"
    content="Corporate Cab Services in Ranchi, Ranchi Business Taxi, Office Cab Hire Ranchi, Chauffeur Corporate Cabs Ranchi, Monthly Cab Rental Ranchi, Ranchi Employee Cab Services, Staff Transport Ranchi, Ranchi Corporate Car Hire, Affordable Corporate Cab Ranchi, Sedan Cab Hire Ranchi, SUV Rental for Business Ranchi, Ranchi Company Taxi, Corporate Travel Cab Ranchi, Online Corporate Cab Booking Ranchi, Best Corporate Taxi Ranchi"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/18.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinranchi;